import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "@/components/ui/dialog"
import { useToast } from "@/components/ui/use-toast"
import clsx from "clsx"
import { useState } from "react"

interface ModalEscolherDezenasProps {
    buscarTitulos: (dezenas: string[]) => void,
    exibirModal: boolean,
    toggleModal: () => void
}

export function ModalEscolherDezenas(props: ModalEscolherDezenasProps) {
    const { toast } = useToast()
    const [dezenasSelecionadas, setDezenasSelecionadas] = useState<string[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    function formatarDezenas(dezenas: string) {
        const dezenasFormatas: number[] = [];

        if(dezenas == null || dezenas == undefined) {
            return [];
        }

        for (let index = 0; index < dezenas.length; index += 2) {
            const dezena = dezenas.slice(index, index + 2);
            dezenasFormatas.push(Number(dezena))
        }

        return dezenasFormatas.map(dezena => `${dezena}`.padStart(2, '0'))
    }

    const dezenas = "010203040506070809101112131415161718192021222324252627282930313233343536373839404142434445464748495051525354555657585960"

    async function handleBuscarTitulos() {
        setLoading(true)
        await props.buscarTitulos(dezenasSelecionadas)
        setLoading(false)
    }

    async function handleSelecionarDezena(dezena: string) {
        const dezenaExists = dezenasSelecionadas.find(d => d === dezena)

        if (dezenaExists) {
            setDezenasSelecionadas(old => [...old.filter(d => d !== dezena)])
        } else {
            if (dezenasSelecionadas.length == 20) {
                toast({
                    variant: 'destructive',
                    description: 'Você não pode selecionar mais de 20 dezenas',
                    duration: 3000
                })
                return;
            }
            setDezenasSelecionadas(old => [...old, dezena])
        }
    }

    return (<Dialog open={props.exibirModal} onOpenChange={props.toggleModal}>


        <DialogContent className="min-w-[40%]">
            <DialogTitle className="text-primary-foreground font-semibold text-xl my-2 text-center">
                Selecione as Dezenas
            </DialogTitle>

            <div className="flex flex-col gap-4 ">
                <Card className='border-2'>
                    <CardContent className="p-3">
                        <div className="flex justify-center mt-2">
                            <div className="flex flex-wrap justify-center w-72 select-none">
                                {
                                    formatarDezenas(dezenas).map((dezena, index) => {
                                        return (
                                            <span onClick={() => handleSelecionarDezena(dezena)} key={`${dezena}-${index}`} className={clsx("cursor-pointer text-xs text-center tabular-nums rounded-full m-1 p-3 border-2 shadow-md", { 'bg-primary': dezenasSelecionadas.find(d => d === dezena) })}>
                                                {dezena}
                                            </span>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
            <DialogFooter className="flex">
                <Button
                    disabled={loading}
                    type="button" onClick={handleBuscarTitulos}
                    className='m-1'>
                    {
                        loading ? 'Buscando...' : 'Buscar'
                    }
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog >)
}